import { Configuration, StationApi, GridApi } from '@/api/out';
import AppConfigStore from '@/stores/config/app-config-module';

interface DataApi {
  stationApi: StationApi;
  gridApi: GridApi;
}

export class ApiStore {
  /**
   * Get an instance of the DataApi. This is a getter because the apiUrl is only
   * available after the url has been successfully loaded.
   */
  static get dataApi(): DataApi {
    const apiUrl = AppConfigStore.dataApiUrl;
    const configuration = new Configuration({ basePath: apiUrl });
    const stationApi = new StationApi(configuration);
    const gridApi = new GridApi(configuration);

    return {
      stationApi,
      gridApi,
    };
  }
}
